/* Diccionario de textos — ES / EN */
export const dict = {
    es: {
        announcementStrong: "Entrega hoy",
        announcementRest: "Pide antes de las 18h",
        deliveryMarquee: ["Entrega hoy en Marbella", "Pide antes de las 18h", "Entrega en mano y con discreción"],
        nav: {
            gifts: "Regalos",
            lovePack: "Love Pack",
            delivery: "Entrega",
            faq: "FAQ",
            menu: "Menú",
            close: "Cerrar",
        },
        hero: {
            eyebrow: "Regalos románticos · Entrega hoy en Marbella",
            badge: "Entrega hoy en Marbella",
            title: "Haz que se sienta única.",
            sub: "No es solo un regalo. Es el momento que nunca olvidará.",
            ctaPrimary: "Preparar su sorpresa",
            ctaSmall: "Rosas · Osito personalizado · Sorpresa con globos",
        },
        trust: [
            "Entrega el mismo día",
            "Regalos personalizados",
            "Discreción y cuidado",
            "En toda la zona de Marbella",
        ],
        products: {
            title: "Nuestros regalos",
            sub: "Cuatro experiencias, un mismo objetivo: sorprender.",
            from: "desde",
            btnProduct: "Ver producto",
            btnCustomize: "Personalizar",
        },
        reassure: {
            label: "Por qué Amor Sin Aviso",
            title: "Todo pensado para sorprenderla.",
            sub: "Del primer detalle hasta el momento en que lo recibe.",
            items: [
                { title: "Entrega el mismo día", text: "Sorprende hoy en Marbella." },
                { title: "Hecho para esa persona", text: "Su nombre, tu mensaje, vuestro momento." },
                { title: "El efecto sorpresa", text: "Una reacción que no se olvida." },
                { title: "Marbella y alrededores", text: "Entrega local, cuidada y discreta." },
            ],
            cta: "Preparar su sorpresa",
        },
        reviews: {
            title: "Lo que dicen nuestros clientes",
            barCount: "1 782 opiniones de clientes",
        },
        delivery: {
            title: "Entrega en Marbella",
            sub: "Llevamos tu sorpresa a hoteles, villas, playas y puertos, con discreción y cuidado.",
            zonesBtn: "Ver zonas de entrega",
            hideZonesBtn: "Ocultar zonas de entrega",
            zones: [
                "Puerto Banús y Marina",
                "Milla de Oro",
                "Nueva Andalucía y Golf Valley",
                "Marbella Centro y Casco Antiguo",
                "San Pedro de Alcántara y Guadalmina",
                "Benahavís",
                "Estepona",
                "Fuengirola",
                "Hoteles de lujo y villas privadas",
            ],
            icons: [
                "Entrega el mismo día",
                "Tarjeta escrita a mano",
                "Embalaje premium",
                "Soporte por WhatsApp",
            ],
        },
        places: {
            title: "Sorprende en los lugares más especiales de Marbella.",
            items: [
                "Hoteles y villas",
                "Playas y puertos",
                "Restaurantes",
                "Domicilios privados",
            ],
        },
        faq: {
            title: "Preguntas frecuentes",
            items: [
                {
                    q: "¿Puedo enviar una sorpresa hoy mismo?",
                    a: "¡Sí! Ofrecemos entrega el mismo día en Marbella para pedidos realizados antes de la hora límite, siempre que haya disponibilidad. Selecciona la fecha de entrega al preparar tu sorpresa.",
                },
                {
                    q: "¿Dónde entregáis los regalos?",
                    a: "Realizamos entregas en Marbella y zonas cercanas, como Puerto Banús, Nueva Andalucía, San Pedro de Alcántara y la Milla de Oro. Para otras localidades, consúltanos antes de realizar tu pedido.",
                },
                {
                    q: "¿La persona sabrá quién le envía el regalo?",
                    a: "¡Solo si tú quieres! Podemos mantener tu identidad en secreto para que la sorpresa sea aún más especial. Tú decides qué escribir en la tarjeta.",
                },
                {
                    q: "¿Puedo personalizar el osito con un nombre o mensaje?",
                    a: "¡Por supuesto! Puedes elegir el nombre o mensaje que aparecerá en su camiseta. Preparamos cada detalle especialmente para esa persona.",
                },
                {
                    q: "¿Cómo funciona la caja sorpresa con globos?",
                    a: "La magia empieza al abrirla. Dentro de la caja encontrarás globos de corazón inflados con helio que se elevan al levantar la tapa, creando un momento inolvidable.",
                },
                {
                    q: "¿Puedo añadir algo más a mi sorpresa?",
                    a: "¡Claro! Puedes completar tu regalo con detalles adicionales, como una rosa roja, bombones u otros complementos disponibles. Porque a veces un pequeño detalle lo cambia todo.",
                },
                {
                    q: "¿Qué pasa si la persona no está en casa?",
                    a: "Si no conseguimos realizar la entrega, intentaremos contactar con la persona destinataria o contigo para buscar una solución. Cualquier nuevo intento de entrega dependerá de la disponibilidad y podrá tener un coste adicional.",
                },
                {
                    q: "¿Puedo elegir la fecha y añadir un mensaje personal?",
                    a: "¡Sí! Puedes seleccionar la fecha de entrega y escribir una dedicatoria para acompañar tu regalo. Nosotros nos encargamos de prepararlo con cariño y discreción.",
                },
            ],
        },
        product: {
            back: "Inicio",
            breadcrumbAll: "Nuestros regalos",
            opt1: "Elige tu ramo",
            opt2: "Texto en la camiseta del osito",
            opt3: "Mensaje en la tarjeta regalo",
            opt4: "Fecha de entrega deseada",
            rosesUnit: "rosas",
            shirtPlaceholder: "Ej. Te amo, Sofía",
            shirtMax: 50,
            messagePlaceholder: "Escribe tu mensaje…",
            messageMax: 200,
            datePlaceholder: "Selecciona una fecha",
            optional: "opcional",
            addToCart: "Añadir al carrito",
            addToCartShort: "Añadir",
            added: "Añadido al carrito",
            accordionDesc: "Descripción",
            accordionDelivery: "Información de entrega",
            accordionFaq: "Preguntas frecuentes",
            includesTitle: "El pack incluye",
            deliveryInfo:
                "Entrega en mano en Marbella y alrededores. Eliges la fecha deseada al personalizar tu regalo. Gastos de envío: 9 €.",
            demoNote: "Entrega en mano en Marbella · pago seguro vía Shopify",
        },
        teddy: {
            colorLabel: "Color",
            personTitle: "Personaliza tu regalo",
            personSub: "T-shirt para el osito con su nombre estampado",
            shirtCheck: "T-shirt para el osito",
            shirtCheckSub: "Un t-shirt a su talla.",
            shirtTextLabel: "El nombre en el t-shirt",
            shirtTextSub: "Solo el nombre de pila de esa persona (ej. Laura), estampado en el t-shirt.",
            yourText: "El nombre",
            charsMax: "Ej. Laura",
        },
        pack: {
            rosesHint: "cuantas más rosas, más grande el ramo",
            includesTitle: "Todo lo que incluye",
            includes1: "Ramo de rosas frescas",
            includes2: "Osito con camiseta personalizada",
            includes3: "Caja sorpresa con globo corazón de helio",
            includes4: "Tarjeta regalo incluida",
            deliveryToday: "Entrega hoy",
            deliveryIn: "si pides en las",
            deliverySub: "Entrega en Marbella y alrededores",
            deliveryTomorrow: "Entrega mañana",
            deliveryTomorrowSub: "Pasadas las 18h, la entrega pasa al día siguiente.",
            shirtNameTitle: "El nombre que irá en el t-shirt del osito",
            shirtNamePlaceholder: "Solo el nombre — ej. Laura",
            shirtNameHint: "Escribe solo el nombre de pila de esa persona; lo estampamos en el t-shirt.",
            shirtNameError: "Dinos el nombre para la camiseta del osito",
            surpriseTitle: "Personaliza la sorpresa",
            surpriseOption: "Texto personalizado en el globo o embalaje",
            surprisePlaceholder: "Escribe tu texto…",
            cardTitle: "Tarjeta regalo",
            cardMessageLabel: "Tu mensaje",
            cardMessagePlaceholder: "Escribe tu mensaje…",
            zoneTitle: "¿Dónde entregamos tu sorpresa?",
            addressPlaceholder: "Dirección: calle, número, piso…",
            postalPlaceholder: "Código postal",
            additionalPlaceholder: "Información adicional (opcional): ej. dejar en recepción…",
            whenTitle: "¿Cuándo quieres entregarlo?",
            slotLabel: "Franja horaria",
            asapOption: "Lo antes posible",
            recipientTitle: "Datos de quien recibe",
            recipientName: "Nombre",
            recipientNamePlaceholder: "Ej. María",
            recipientPhone: "Teléfono",
            recipientPhonePlaceholder: "+34 600 123 456",
            recipientPlace: "Hotel, villa, restaurante o apartamento",
            recipientPlacePlaceholder: "Ej. Hotel Puente Romano",
            reassurance1: "Entrega local en Marbella",
            reassurance2: "Tarjeta regalo incluida",
            reassurance3: "Personalización preparada para ti",
            reassurance4: "Confirmación de entrega",
        },
        ramo: {
            cardIncluded: "Tarjeta regalo incluida",
            messageLabel: "Tu mensaje en la tarjeta",
            freeTag: "gratis",
            messagePlaceholder: "Escrito a mano por nuestras floristas. Déjalo vacío si no quieres mensaje.",
            personalizeTitle: "Personaliza tu regalo",
            redBalloonOption: "Globo de corazón con helio ❤️",
            redBalloonDesc: "Globo rojo en forma de corazón, inflado con helio y entregado junto a tu ramo de rosas.",
            balloonTextOption: "Escritura en el globo",
            yourTextLabel: "Tu texto",
            charsMax: "40 caracteres máximo",
        },
        extras: {
            title: "Haz su sorpresa aún más especial ❤️",
            subtitle: "Pequeños detalles que hacen que el momento sea inolvidable.",
            cardMessageTitle: "Tu mensaje para la tarjeta",
            freeHint: "2 o más artículos: entrega gratuita 🎁",
            freeDelivery: "Entrega gratuita desbloqueada",
            freeShort: "Envío gratis",
            add: "Añadir +",
            added: "Añadido",
        },
        cart: {
            title: "Tu carrito",
            free: "Gratis",
            redirecting: "Redirigiendo…",
            secureNote: "Pago seguro a través de Shopify. Serás redirigido para completar el pago.",
            color: "Color",
            shirtOsito: "T-shirt del osito",
            empty: "Tu carrito está vacío",
            emptySub: "Descubre nuestros regalos y empieza tu sorpresa.",
            emptyCta: "Ver regalos",
            subtotal: "Subtotal",
            shipping: "Entrega en Marbella",
            total: "Total",
            checkout: "Finalizar compra",
            demoCheckout: "Modo demostración",
            demoCheckoutDesc:
                "El pago aún no está activado. En la próxima fase se conectará Shopify.",
            roses: "rosas",
            shirt: "Texto osito",
            card: "Mensaje en tarjeta",
            deliveryOn: "Fecha",
            remove: "Eliminar",
            qtyMinus: "Reducir cantidad",
            qtyPlus: "Aumentar cantidad",
            cardStyle: "Tarjeta",
            packExtra: "Personalización: embalaje y globo",
        },
        footer: {
            tagline: "Regalos románticos entregados en mano en Marbella.",
            demoNote: "Pagos gestionados de forma segura por Shopify",
            rights: "Todos los derechos reservados",
            location: "Marbella · Costa del Sol · España",
        },
    },
    en: {
        announcementStrong: "Delivery today",
        announcementRest: "Order before 6 PM",
        deliveryMarquee: ["Same-day delivery in Marbella", "Order before 6 PM", "Hand-delivered with care"],
        nav: {
            gifts: "Gifts",
            lovePack: "Love Pack",
            delivery: "Delivery",
            faq: "FAQ",
            menu: "Menu",
            close: "Close",
        },
        hero: {
            eyebrow: "Romantic gifts · Delivered today in Marbella",
            badge: "Same-day delivery in Marbella",
            title: "Make her feel one of a kind.",
            sub: "It's not just a gift. It's the moment she'll never forget.",
            ctaPrimary: "Prepare her surprise",
            ctaSmall: "Roses · Personalized teddy · Balloon surprise",
        },
        trust: [
            "Same-day delivery",
            "Personalized gifts",
            "Discretion and care",
            "Across the whole Marbella area",
        ],
        products: {
            title: "Our gifts",
            sub: "Four experiences, one single goal: the surprise.",
            from: "from",
            btnProduct: "View product",
            btnCustomize: "Personalize",
        },
        reassure: {
            label: "Why Amor Sin Aviso",
            title: "Everything designed to surprise her.",
            sub: "From the first detail to the moment she receives it.",
            items: [
                { title: "Same-day delivery", text: "Surprise her today in Marbella." },
                { title: "Made for that person", text: "Her name, your message, your moment." },
                { title: "The surprise effect", text: "A reaction she'll never forget." },
                { title: "Marbella & surroundings", text: "Local, caring and discreet delivery." },
            ],
            cta: "Prepare her surprise",
        },
        reviews: {
            title: "What our clients say",
            barCount: "1,782 customer reviews",
        },
        delivery: {
            title: "Delivery in Marbella",
            sub: "We bring your surprise to hotels, villas, beaches and ports, with discretion and care.",
            zonesBtn: "View delivery zones",
            hideZonesBtn: "Hide delivery zones",
            zones: [
                "Puerto Banús & Marina",
                "Golden Mile",
                "Nueva Andalucía & Golf Valley",
                "Marbella Centre & Old Town",
                "San Pedro de Alcántara & Guadalmina",
                "Benahavís",
                "Estepona",
                "Fuengirola",
                "Luxury hotels & private villas",
            ],
            icons: [
                "Same-day delivery",
                "Handwritten card",
                "Premium packaging",
                "WhatsApp support",
            ],
        },
        places: {
            title: "Surprise them in Marbella's most special places.",
            items: [
                "Hotels & villas",
                "Beaches & ports",
                "Restaurants",
                "Private homes",
            ],
        },
        faq: {
            title: "Frequently asked questions",
            items: [
                {
                    q: "Can I send a surprise today?",
                    a: "Yes! We offer same-day delivery in Marbella for orders placed before the cutoff time, subject to availability. Select the delivery date when preparing your surprise.",
                },
                {
                    q: "Where do you deliver gifts?",
                    a: "We deliver in Marbella and nearby areas such as Puerto Banús, Nueva Andalucía, San Pedro de Alcántara and the Golden Mile. For other locations, please check with us before placing your order.",
                },
                {
                    q: "Will the person know who sent the gift?",
                    a: "Only if you want! We can keep your identity secret to make the surprise even more special. You decide what to write on the card.",
                },
                {
                    q: "Can I personalize the teddy bear with a name or message?",
                    a: "Of course! You can choose the name or message that will appear on its t-shirt. We prepare every detail especially for that person.",
                },
                {
                    q: "How does the surprise box with balloons work?",
                    a: "The magic begins when it's opened. Inside the box you'll find heart balloons inflated with helium that rise when the lid is lifted, creating an unforgettable moment.",
                },
                {
                    q: "Can I add something more to my surprise?",
                    a: "Of course! You can complete your gift with extra details, such as a red rose, chocolates or other available extras. Because sometimes a small detail changes everything.",
                },
                {
                    q: "What happens if the person isn't home?",
                    a: "If we can't complete the delivery, we'll try to contact the recipient or you to find a solution. Any new delivery attempt will depend on availability and may have an additional cost.",
                },
                {
                    q: "Can I choose the date and add a personal message?",
                    a: "Yes! You can select the delivery date and write a dedication to accompany your gift. We take care of preparing it with love and discretion.",
                },
            ],
        },
        product: {
            back: "Home",
            breadcrumbAll: "Our gifts",
            opt1: "Choose your bouquet",
            opt2: "Teddy t-shirt text",
            opt3: "Gift card message",
            opt4: "Preferred delivery date",
            rosesUnit: "roses",
            shirtPlaceholder: "E.g. Te amo, Sofía",
            shirtMax: 50,
            messagePlaceholder: "Write your message…",
            messageMax: 200,
            datePlaceholder: "Select a date",
            optional: "optional",
            addToCart: "Add to cart",
            addToCartShort: "Add",
            added: "Added to cart",
            accordionDesc: "Description",
            accordionDelivery: "Delivery information",
            accordionFaq: "Frequently asked questions",
            includesTitle: "The pack includes",
            deliveryInfo:
                "Hand delivery in Marbella and surrounding areas. You choose your preferred date when personalizing your gift. Delivery fee: €9.",
            demoNote: "Hand delivery in Marbella · secure payment via Shopify",
        },
        teddy: {
            colorLabel: "Colour",
            personTitle: "Personalize your gift",
            personSub: "T-shirt for the teddy with their name printed on it",
            shirtCheck: "T-shirt for the teddy",
            shirtCheckSub: "A t-shirt in its size.",
            shirtTextLabel: "The name on the t-shirt",
            shirtTextSub: "Only their first name (e.g. Laura), printed on the t-shirt.",
            yourText: "The name",
            charsMax: "e.g. Laura",
        },
        pack: {
            rosesHint: "the more roses, the bigger the bouquet",
            includesTitle: "Everything it includes",
            includes1: "Fresh roses bouquet",
            includes2: "Teddy with personalized t-shirt",
            includes3: "Surprise box with helium heart balloon",
            includes4: "Gift card included",
            deliveryToday: "Delivery today",
            deliveryIn: "if you order within",
            deliverySub: "Delivery in Marbella & surroundings",
            deliveryTomorrow: "Delivery tomorrow",
            deliveryTomorrowSub: "After 6 PM, delivery moves to the next day.",
            shirtNameTitle: "The name that will go on the teddy's t-shirt",
            shirtNamePlaceholder: "Just the name — e.g. Laura",
            shirtNameHint: "Only their first name; we print it on the t-shirt.",
            shirtNameError: "Tell us the name for the teddy's t-shirt",
            surpriseTitle: "Personalize the surprise",
            surpriseOption: "Custom text on the balloon or packaging",
            surprisePlaceholder: "Write your text…",
            cardTitle: "Gift card",
            cardMessageLabel: "Your message",
            cardMessagePlaceholder: "Write your message…",
            zoneTitle: "Where do we deliver your surprise?",
            addressPlaceholder: "Address: street, number, apartment…",
            postalPlaceholder: "Postal code",
            additionalPlaceholder: "Additional information (optional): e.g. leave at reception…",
            whenTitle: "When do you want it delivered?",
            slotLabel: "Time slot",
            asapOption: "As soon as possible",
            recipientTitle: "Recipient details",
            recipientName: "Name",
            recipientNamePlaceholder: "e.g. María",
            recipientPhone: "Phone",
            recipientPhonePlaceholder: "+34 600 123 456",
            recipientPlace: "Hotel, villa, restaurant or apartment",
            recipientPlacePlaceholder: "e.g. Hotel Puente Romano",
            reassurance1: "Local delivery in Marbella",
            reassurance2: "Gift card included",
            reassurance3: "Personalization prepared for you",
            reassurance4: "Delivery confirmation",
        },
        ramo: {
            cardIncluded: "Gift card included",
            messageLabel: "Your message on the card",
            freeTag: "free",
            messagePlaceholder: "Handwritten by our florists. Leave it empty if you don't want a message.",
            personalizeTitle: "Personalize your gift",
            redBalloonOption: "Red heart balloon with helium ❤️",
            redBalloonDesc: "A red heart-shaped balloon, inflated with helium and delivered with your rose bouquet.",
            balloonTextOption: "Writing on the balloon",
            yourTextLabel: "Your text",
            charsMax: "40 characters max",
        },
        extras: {
            title: "Make their surprise even more special ❤️",
            subtitle: "Small details that make the moment unforgettable.",
            cardMessageTitle: "Your message for the card",
            freeHint: "2 or more items: free delivery 🎁",
            freeDelivery: "Free delivery unlocked",
            freeShort: "Free delivery",
            add: "Add +",
            added: "Added",
        },
        cart: {
            title: "Your cart",
            free: "Free",
            redirecting: "Redirecting…",
            secureNote: "Secure payment via Shopify. You'll be redirected to complete your payment.",
            color: "Colour",
            shirtOsito: "Teddy t-shirt",
            empty: "Your cart is empty",
            emptySub: "Discover our gifts and start your surprise.",
            emptyCta: "View gifts",
            subtotal: "Subtotal",
            shipping: "Marbella delivery",
            total: "Total",
            checkout: "Checkout",
            demoCheckout: "Demo mode",
            demoCheckoutDesc:
                "Payment is not enabled yet. Shopify will be connected in the next phase.",
            roses: "roses",
            shirt: "Teddy t-shirt",
            card: "Card message",
            deliveryOn: "Date",
            remove: "Remove",
            qtyMinus: "Decrease quantity",
            qtyPlus: "Increase quantity",
            cardStyle: "Card",
            packExtra: "Personalization: packaging & balloon",
        },
        footer: {
            tagline: "Romantic gifts hand-delivered in Marbella.",
            demoNote: "Payments securely handled by Shopify",
            rights: "All rights reserved",
            location: "Marbella · Costa del Sol · Spain",
        },
    },
};
